export default function download(url, filename, currentTab) {
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);

  if (!currentTab) {
    link.setAttribute('target', '_blank');
  }

  link.setAttribute('style', 'visibility:hidden');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
